import { baseApi } from 'api/constant'
import { GenericResponse } from 'model/common'

const Writer = {
    getAuthor: async (authorId: number): Promise<any> => {
        const response = await baseApi.get<GenericResponse>(`figk/author/${authorId}`)
        return response.data
    },
}

export default Writer
